var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tag",
    {
      style: {
        "border-color": _vm.type === "purple" ? "#732cff" : "",
        color: _vm.type === "purple" ? "#732cff" : "",
        "background-color": _vm.type === "purple" ? "#732cff33" : "",
      },
      attrs: { size: _vm.size, hit: _vm.hit, type: _vm.type },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }